<template>
    <div class="container-list">
        <div class="common-page common-head">
            <div class="common-page common-head-title">
                <i class="icon-tr-other"></i>
                新增设备表
            </div>
        </div>
        <el-form ref="form" :model="form" label-width="110px" :rules="rules">
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item label="设备编号" prop="device_code" :rules="{message:'请填写/选择',trigger:'blur',required:true}">
                        <el-input v-model="form.device_code" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="设备型号" prop="model">
                        <el-input v-model="form.model" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="设备信息" prop="model_extend"  :rules="{message:'请填写/选择',trigger:'change',required:true}" >
                        <el-select v-model="form.model_extend">
                            <el-option v-for="item in infoOpts" :value="item" :key="item"> {{item}}</el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="设备类型" prop="type">
                        <v-select :value.sync="form.type" :id="123"></v-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="设备名称" prop="name" >
                        <el-input v-model="form.name" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                 <el-col :span="6">
                    <el-form-item label="单位名称" prop="company_id" :rules="{message:'请填写/选择',trigger:'change',required:true}">
                        <el-select v-model="form.company_id" placeholder="请选择">
                            <el-option v-for="item in units" :key="item.c_company_num" :label="item.c_name" :value="item.c_company_num"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="通讯模式" prop="mode">
                        <v-select :value.sync="form.mode" :id="130"></v-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="软件版本" prop="soft_version">
                        <el-input v-model="form.soft_version" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="硬件版本" prop="hardware_version">
                        <el-input v-model="form.hardware_version" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="制造商" prop="manufacturer">
                        <el-input v-model="form.manufacturer" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="制造商地址" prop="manufacturer_add">
                        <el-input v-model="form.manufacturer_add" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="联系电话" prop="phone">
                        <el-input v-model="form.phone" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="联系人" prop="contact_person">
                        <el-input v-model="form.contact_person" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="东经" prop="lon" :rules="{message:'请填写/选择',trigger:'blur',required:true}">
                        <el-input v-model="form.lon" placeholder="请输入" ></el-input>
                        <getLoation  @callback="getLoa"></getLoation>
                    </el-form-item>

                </el-col>
                <el-col :span="6">
                    <el-form-item label="北纬" prop="lat" :rules="{message:'请填写/选择',trigger:'blur',required:true}">
                        <el-input v-model="form.lat" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="13">
                        <el-form-item label="附件上传">
                            <el-upload
                                    :file-list="fileList"
                                    :on-success="uploadSuccess"
                                    :on-remove="removeFile"
                                    drag
                                    :action="`${$bus.config.host}/devicemanage/uploaddevicephoto`"
                                    accept="image/*"
                                    multiple>
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            </el-upload>
                            <div v-for="item in fileList" class="mt10">
                                <a :href="item.url" target="_blank" class="blue">{{item.name}}  下载/查看</a>
                            </div>
                        </el-form-item>
                </el-col>
            </el-row>

            <div class="btn-box center">
                <div class="l-btn" @click="onSubmit">保存</div>
                <div class="l-btn ml20" @click="$router.back()">返回</div>
            </div>

        </el-form>


    </div>
</template>

<script>
    import getLoation from './getLoation'
    export default {
        components:{getLoation},
        data(){
            return{
                form:{
                    name:'',
                    model:'',
                    model_extend:'',
                   company_id:'',
                    type:'',
                    device_code:'',
                    mode:'',
                    soft_version:'',
                    hardware_version:'',
                    manufacturer:'',
                    manufacturer_add:'',
                    phone:'',
                    contact_person:'',
                    lon:'',
                    lat:'',
                    picname:[]
                },
                fileList:[],
                  units:[],
                infoOpts:["水位","水压","电气火灾监控设备","用户信息传输装置","无线烟感","RTU","其他"],
                showMap:false,
                rules: {
                }
            }
        },
        created(){
               this.$get('/user/roleandcompany').then(res=>{
                
                this.units = res.data.company
             
            })
            if(this.$route.query.id){
                this.$post('/devicemanage/findbyid',{uuid:this.$route.query.id}).then(res=>{
                    this.form = res.data
                    this.form.mode = +res.data.mode
                    this.form.type = +res.data.type
                    res.data.picname.forEach((it,index)=>{
                        this.fileList.push({name:'附件'+(index+1),url:it})
                    })

                })
            }
            
        },
        methods:{
            getLoa(val){
              this.form.lon = val[0]
                this.form.lat = val[1]
            },
            uploadSuccess(res, file, fileList){
                log(res,file, fileList)
                var arr = []
                fileList.forEach(it=>{
                    if(it.response){
                        arr.push(...it.response.image_uuid)
                    }else if(it.url){
                        arr.push(it.url)
                    }
                })
                this.fileList = []
                arr.forEach((it,index)=>{
                    this.fileList.push({name:'附件'+(index+1),url:it})
                })
                this.form.picname = arr
            },
            removeFile(file, fileList){
                var arr = []
                fileList.forEach(it=>{
                    arr.push(it.url)
                })
                this.fileList = []
                arr.forEach((it,index)=>{
                    this.fileList.push({name:'附件'+(index+1),url:it})
                })
                this.form.picname = arr
            },
            onSubmit() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.save()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            save(){
                let loading = this.$loading({background: 'rgba(0, 0, 0, 0.6)'})
                let api = this.$route.query.id ? '/devicemanage/updatebyid' : '/devicemanage/add';
                this.$post(api,this.form).then(res=>{
                    // this.$message.success('保存成功')
                    this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
                    this.$router.back()
                    loading.close()
                }).catch(err=>{
                    loading.close()
                })

            }
        }
    }
</script>

<style scoped>

</style>
